import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopOnNavigate = () => {
  const { pathname, hash } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    // Only scroll to top if pathname changed and there's no hash (anchor)
    if (prevPathnameRef.current !== pathname && !hash) {
      // Use requestAnimationFrame to ensure it runs after render
      requestAnimationFrame(() => window.scrollTo(0, 0));
    }
    prevPathnameRef.current = pathname;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTopOnNavigate;